export const getAuthorName = ({
  node: { name, firstName, lastName },
}) => {
  return name || `${firstName} ${lastName}`;
};

export const formatReadingTime = readingTime =>
  `${readingTime} min read`;
